import { Component, h, Prop, Listen } from '@stencil/core';

@Component({
    tag: 'rentware-tabs-skeleton',
    styleUrl: 'style.sass',
    shadow: false,
})
export class RentwareTabsSkeleton {
    @Prop() tabs;

    tabsContainerWidth: number;
    selectedTabParent: HTMLDivElement;
    singleTabs: HTMLDivElement[] = [];

    componentDidLoad() {
        this.distributeTabs();
    }

    @Listen('resize', { target: 'window' })
    distributeTabs() {
        const tabInitialWidth = 100;
        this.tabsContainerWidth = this.selectedTabParent?.offsetWidth; // all width that we can see
        const numberOfTabs = this.tabs.length;

        // case 1 - all tabs need less or equal space than is available
        if (numberOfTabs * tabInitialWidth <= this.tabsContainerWidth) {
            const widthOfTab = Math.floor(this.tabsContainerWidth / numberOfTabs);
            this.singleTabs?.map((item) => item.style.width = widthOfTab + "px");
        } else { // case 2 - all tabs need more space than is available
            const numberOfTabsShown = Math.floor((this.tabsContainerWidth + tabInitialWidth * 0.5) / tabInitialWidth) - 1;
            const widthOfTab = Math.floor(this.tabsContainerWidth / (numberOfTabsShown + 0.5));
            this.singleTabs?.map((item) => item.style.width = widthOfTab + "px");
        }
    }

    componentWillUpdate() {
        this.distributeTabs();
    }

    mappedTab = () => {
        return (
            <div
                class="TabContainer"
                ref={(el) => this.singleTabs.push(el as HTMLDivElement)}
            >
                <div class="TabImage SkeletonTabsBg" />

                <div class="TabTitle SkeletonTabsBg SkeletonTabsTitle" />
            </div>
        );
    }

    render() {
        return (
            <div
                class="CheckOutTabsContainer"
                ref={(el) => this.selectedTabParent = el as HTMLDivElement}
            >
                <div
                    class="TabsContainerInner"
                >
                    {this.tabs.map(this.mappedTab)}
                </div >
            </div >
        )
    }
}
